import { render, staticRenderFns } from "./CancelarAssinatura.vue?vue&type=template&id=ce03515a&"
import script from "./CancelarAssinatura.vue?vue&type=script&lang=js&"
export * from "./CancelarAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports